import { useState, useEffect, useCallback } from 'react';
import { getInfluencerByUsername } from '../services/marketplaceApi';

/**
 * Fetch a single marketplace influencer by username.
 * @param {string} username - Influencer username (from route params)
 * @returns {{ influencer: object|null, loading: boolean, error: Error|null, refetch: function }}
 */
export function useInfluencer(username) {
  const [influencer, setInfluencer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInfluencer = useCallback(async () => {
    if (!username || !String(username).trim()) {
      setInfluencer(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await getInfluencerByUsername(username);
      setInfluencer(data ?? null);
    } catch (err) {
      setError(err);
      setInfluencer(null);
    } finally {
      setLoading(false);
    }
  }, [username]);

  useEffect(() => {
    fetchInfluencer();
  }, [fetchInfluencer]);

  return { influencer, loading, error, refetch: fetchInfluencer };
}

export default useInfluencer;
